<template>
    <div>
        <div v-for="(item, i) in values" :key="i" class="col-lg-12">
          <div class="row m-t-xs">
            <div class="col-lg-5">
              <input type="text" placeholder="key" class="form-control" v-model="item.key" :ref="'keyInput-' + i">
            </div>
            <div class="col-lg-5">
              <input type="text" placeholder="value" class="form-control" v-model="item.value" @keydown.enter="addValue">
            </div>
            <div class="col-lg-2 buttons-container">
              <button v-if="i === 0" class="btn btn-success btn-sm" v-tooltip="'Add new key-value to the list'" @click="addValue">
                <i class="fa fa-plus"></i>
              </button>
              <button class="btn btn-danger btn-sm" v-tooltip="'Remove credential from list'" @click="removeValue(i)">
                <i class="fa fa-multiply"></i>
              </button>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    target: {
      required: true
    },
    returnType: {
      type: String,
      default: 'array',
      validator: function (value) {
        return ['array', 'object'].includes(value)
      }
    }
  },
  data () {
    return {
      values: [{key: '', value: ''}]
    }
  },
  watch: {
    target: {
      immediate: true,
      handler (newTarget) {
        if ((this.returnType === 'object' && !Object.keys(newTarget).length) || !newTarget.length) {
          this.values = [{key: '', value: ''}]
        }
      }
    }
  },
  methods: {
    addValue () {
      const {key, value} = this.values[0]
      if (!key.trim().length || !value.trim().length) {
        this.$toastr.warning('Please fill the current field before adding a new one')
        return
      }
      if (this.returnType === 'object' && !this.isKeyUnique(key)) {
        this.$toastr.warning('You already entered this key. Please enter a different one')
        return
      }
      this.values.unshift({key: '', value: ''})
      this.returnType === 'object' ? this.target[key] = value : this.target.push({key: key, value: value})
      this.focusOnNextKeyInput(0)
    },
    focusOnNextKeyInput (index) {
      this.$nextTick(() => {
        let inputRef = 'keyInput-' + index
        this.$refs[inputRef][0].focus()
      })
    },
    removeValue (index) {
      if (this.values.length === 1) {
        this.$toastr.warning('Cannot remove the only value in the list')
        return
      }
      let removed = this.values.splice(index, 1)
      this.returnType === 'object' ? delete this.target[removed[0].key] : this.target.splice(index, 1)
    },
    isKeyUnique (key) {
      return !Object.keys(this.target).includes(key)
    }
  }
}
</script>
<style scoped>
.buttons-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Helpers/Modal/KeyValueInterface.vue